import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbModule } from 'angular-crumbs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NiceSelectModule } from 'ng-nice-select';
import { FormsModule } from '@angular/forms';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SearchBoxComponent } from './search-box/search-box.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CanvasComponent } from './canvas/canvas.component';
import { BlogSidebarComponent } from './blog-sidebar/blog-sidebar.component';
import { GlobalModule } from '../../global/global.module';
import { SearchPipe } from '../directives/searchBlogs';
import { RepeaterComponent } from './repeater/repeater.component';
import { ParagraphsModule } from '../paragraphs/paragraphs.module';



@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SearchBoxComponent,
    BreadcrumbComponent,
    CanvasComponent,
    BlogSidebarComponent,
    RepeaterComponent,
    SearchPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    BreadcrumbModule,
    NiceSelectModule,
    FormsModule,
    SlickCarouselModule,
    GlobalModule,
    ParagraphsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    BreadcrumbComponent,
    BlogSidebarComponent,
    RepeaterComponent,
    SearchPipe
  ]
})
export class SharedModule { }
